import { initStore } from '../../../common';
import { actions } from './actions';

export const loginStore = (): void => {
	const initialState = {
		slice: 'LOGIN',
		email: '',
		emailInvalid: false,
		password: '',
		two_step_code: '',
		errors: [],
		success: '',
		loginType: '',
	};

	initStore(actions, initialState);
};
